import {fetchUserStatus, fetchBlockReasons} from '../api/block-user.api';
import {IBlockReasonService} from '../model/types';

export const BlockReasonService = {
    changeUserStatus: async ({url, reasonId, reasonComment, autoUnlocking}: IBlockReasonService) => {
        try {
            const response = await fetchUserStatus({url, data: {reasonId, reasonComment, autoUnlocking}});

            return {response, isError: false};
        } catch (error) {
            console.error(error);
            return {response: error.response, isError: true};
        }
    },

    getBlockListReasons: async () => {
        try {
            return await fetchBlockReasons();
        } catch (error) {
            console.error(error);
            if (error.response.status === 404) {
                throw error;
            }
            throw new Error(`Ошибка при получении причин блокировки: ${error.message}`);
        }
    },
};
